import { IInitalAddValues } from '../types/bank-account'
import { getUserFromToken } from '../utils/getUserFromToken'
import { APIDecoratorWithBaseURI } from './api'
//
//
// este arquivo todo pode ser atualizado para usar o SWR
// deixo esse comentário para que apos o saque ser movido
// para dev lembrar de assinar uma task para atualizar isso
//
//
export interface getBankAccountsProps {
  success: boolean
  data: IBankAccountProps[] | null
}

export interface IBankAccountProps {
  id: number
  nationalRegistration: string
  accountOwner: string
  agency: string
  accountNumber: string
  accountDigit: string
  accountType: string
  accountIdentifier: string
  bank: string
  bankName: string
}

const PA_PREFIX = 'producer/analytics/'

export const updateBankAccountRequest = async (
  token: string,
  payload: IInitalAddValues
): Promise<boolean> => {
  const user = getUserFromToken(token)
  const url = `${PA_PREFIX}updateBankAccounts`
  const newPayload = {
    Id: payload.id,
    CnpjCpf: payload.nationalRegistration,
    Titular: payload.accountOwner,
    Banco: JSON.parse(payload.bank).number,
    Agencia: payload.agency,
    Conta: payload.accountNumber,
    Tipo: JSON.parse(payload.accountType).value,
    Identificador: payload.accountIdentifier,
    UsuarioId: user.id,
    TipoTransacao: payload.transactionType,
    TipoChavePix: payload.pixTypeKey,
    ChavePix: payload.pixKey,
  }

  const data = await APIDecoratorWithBaseURI()
    .put<any>(url, newPayload as any)
    .then((response: any): boolean => {
      return response.data.success
    })
    .catch((e) => {
      return false
    })
  return data
}

export const createBankAccount = async (
  token: string,
  payload: IInitalAddValues
): Promise<boolean> => {
  const url = `${PA_PREFIX}createBankAccounts`
  const user = getUserFromToken(token)
  const newPayload = {
    CnpjCpf: payload.nationalRegistration,
    Titular: payload.accountOwner,
    Banco: payload.bank,
    Agencia: payload.agency,
    Conta: payload.accountNumber,
    ContaDigito: payload.accountDigit,
    Tipo: payload.accountType,
    Identificador: payload.accountIdentifier,
    UsuarioId: user.id,
    TipoTransacao: payload.transactionType,
    TipoChavePix: payload.pixTypeKey,
    ChavePix: payload.pixKey,
  }
  const data = await APIDecoratorWithBaseURI()
    .post<any>(url, newPayload)
    .then((response: any): boolean => {
      return response.data.success
    })
    .catch((e: any) => {
      console.error('createBankAccount', e)
      return false
    })
  return data
}

export const deleteBankAccountRequest = async (
  token: string,
  payload: string | number
): Promise<boolean> => {
  const user = getUserFromToken(token)
  const url = `${PA_PREFIX}deleteBankAccounts?producerId=${user.id}&accountId=${payload}`

  const data = await APIDecoratorWithBaseURI()
    .delete(url)
    .then((r: any): boolean => {
      if (r.status === 200) return true
      if (r.status !== 200) return false
      return true
    })
    .catch((e: any) => {
      console.error('deleteBankAccountRequest', e)
      return false
    })
  return data
}

// @deprecated
// now using swr in /hooks/account/index.tsx
export const getBankAccounts = async (
  token: string
): Promise<getBankAccountsProps> => {
  const user = getUserFromToken(token)
  const url = `${PA_PREFIX}getBankAccounts?producerId=${user.id}`
  const data = await APIDecoratorWithBaseURI()
    .get<any>(url)
    .then((response: any) => {
      return response.data as getBankAccountsProps
    })
    .catch((e: any) => {
      console.error('getBankAccounts', e)
      return {
        success: false,
        data: null,
      }
    })
  return data
}
